module.exports = __webpack_public_path__ + "img/contact_bg.30c4c69c.jpg";